import { REQUEST, SUCCESS, FAILURE } from 'Redux/actions/constants'
import { actionCreator, createRequestTypes, createApiActions } from 'Redux/actions'


// // USER SEARCHES ////
export const LOAD_USER_SEARCHES = 'LOAD_USER_SEARCHES'
export const loadUserSearches = ({ leadId }) => actionCreator(LOAD_USER_SEARCHES, { leadId })

export const USER_SEARCHES = createRequestTypes('USER_SEARCHES')
export const getUserSearches = createApiActions(USER_SEARCHES)

export const API_SAVE_USER_SEARCH = createRequestTypes('API_SAVE_USER_SEARCH')
export const apiSaveUserSearch = createApiActions(API_SAVE_USER_SEARCH)

// //////////////////////
export const SAVE_SEARCH_CLEAR_MSG = 'SAVE_SEARCH_CLEAR_MSG'
export const saveSearchClearMsg = () => actionCreator(SAVE_SEARCH_CLEAR_MSG)

// //////////////////////
export const DELETE_USER_SEARCH = 'DELETE_USER_SEARCH'
export const deleteUserSearch = ({ id }) => actionCreator(DELETE_USER_SEARCH, { id })

export const API_DELETE_USER_SEARCH = createRequestTypes('API_DELETE_USER_SEARCH')
export const apiDeleteUserSearch = {
  request: (data) => actionCreator(API_DELETE_USER_SEARCH[REQUEST], data),
  success: (defaults, response) => actionCreator(API_DELETE_USER_SEARCH[SUCCESS], { response, request: defaults }),
  failure: (defaults, error) => actionCreator(API_DELETE_USER_SEARCH[FAILURE], { error }),
}

// //////////////////////
export const UPDATE_USER_SEARCH = 'UPDATE_USER_SEARCH'
export const updateUserSearch = ({ id, frequency, name, url, selectedFiltersList, userId }) =>
  actionCreator(UPDATE_USER_SEARCH, { id, frequency, name, url, selectedFiltersList, userId }) // eslint-disable-line

export const API_UPDATE_USER_SEARCH = createRequestTypes('API_UPDATE_USER_SEARCH')
export const apiUpdateUserSearch = {
  request: (data) => actionCreator(API_UPDATE_USER_SEARCH[REQUEST], data),
  success: (defaults, response) => actionCreator(API_UPDATE_USER_SEARCH[SUCCESS], { response, request: defaults }),
  failure: (defaults, error) => actionCreator(API_UPDATE_USER_SEARCH[FAILURE], { error }),
}

// /////////////////////
export const LOAD_SAVED_SEARCH_LISTINGS = 'LOAD_SAVED_SEARCH_LISTINGS'
export const loadSavedSearchListings = (query, buildingId) =>
  actionCreator(LOAD_SAVED_SEARCH_LISTINGS, { query, buildingId })

export const ALG_SAVED_SEARCH_BUILDING_LISTINGS = createRequestTypes('ALG_SAVED_SEARCH_BUILDING_LISTINGS')

export const TURN_OFF_ALL_LISTING_ALERTS = 'TURN_OFF_ALL_LISTING_ALERTS'
export const turnOffAllListingAlerts = () => actionCreator(TURN_OFF_ALL_LISTING_ALERTS)

export const LOAD_ALERT_LISTINGS = 'LOAD_ALERT_LISTINGS'
export const loadAlertListings = ({ alertId, query, perPage = 4, requireMeta = true }) =>
  actionCreator(LOAD_ALERT_LISTINGS, { alertId, query, requireMeta, perPage })

export const FETCH_ALERT_LISTINGS_API = createRequestTypes('FETCH_ALERT_LISTINGS_API')
export const fetchAlertListingsActions = createApiActions(FETCH_ALERT_LISTINGS_API)

export const UPDATE_ALERT_TAGS_API = createRequestTypes('UPDATE_ALERT_TAGS_API')
export const updateAlertTagsApiActions = createApiActions(UPDATE_ALERT_TAGS_API)

export const UPDATE_ALERT_REBUILD_TAGS = 'UPDATE_ALERT_REBUILD_TAGS'
export const updateAlertRebuildTags = ({ updateAlertsObj }) =>
  actionCreator(UPDATE_ALERT_REBUILD_TAGS, { updateAlertsObj })
